import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    initialize() {
        super.initialize();

        this.debounceTimer = null;
        this.dragEnabled = false;
        this.dragStarted = false;
        this.startX = null;
        this.scrollLeft = null;

        this.dStart = (e) => this.dragStart(e);
        this.dStop = (e) => this.dragStop(e);
        this.dMove = (e) => this.dragMove(e);
        this.sChange = (e) => this.scrollChange(e);
    }

    connect() {
        super.connect();

        this.disableClicksOnScroll = this.element.hasAttribute('data-disable-clicks-on-scroll');

        this.element.addEventListener('scroll', this.sChange);
        this.element.addEventListener('mousedown', this.dStart);
        this.element.addEventListener('mouseup', this.dStop);
        this.element.addEventListener('mouseleave', this.dStop);
        this.element.addEventListener('mousemove', this.dMove);

        if (this.element.hasAttribute('id') && localStorage.getItem(`horizontal-drag-offset-${this.element.getAttribute('id')}`)) {
            this.element.scrollLeft = Number(localStorage.getItem(`horizontal-drag-offset-${this.element.getAttribute('id')}`));
        }
    }

    disconnect() {
        this.element.removeEventListener('scroll', this.sChange);
        this.element.removeEventListener('mousedown', this.dStart);
        this.element.removeEventListener('mouseup', this.dStop);
        this.element.removeEventListener('mouseleave', this.dStop);
        this.element.removeEventListener('mousemove', this.dMove);

        super.disconnect();
    }

    scrollChange() {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
            if (this.element.hasAttribute('id')) {
                localStorage.setItem(`horizontal-drag-offset-${this.element.getAttribute('id')}`, String(this.element.scrollLeft));
            }
        }, 250);
    }

    dragMove(event) {
        if (this.dragEnabled) {
            event.preventDefault();

            if (!this.dragStarted && this.disableClicksOnScroll) {
                this.disableChildren();
            }

            this.dragStarted = true;
            const x = event.pageX - this.element.offsetLeft;
            const scrollX = x - this.startX;
            this.element.scrollLeft = this.scrollLeft - scrollX;
        }
    }

    dragStart(event) {
        this.startX = event.pageX - this.element.offsetLeft;
        this.scrollLeft = this.element.scrollLeft;
        this.dragEnabled = true;
    }

    dragStop() {
        this.dragStarted = false;
        this.dragEnabled = false;
        this.enableChildren();
    }

    disableChildren() {
        for (const child of this.element.children) {
            child.classList.add('pointers-none');
        }
    }

    enableChildren() {
        for (const child of this.element.children) {
            child.classList.remove('pointers-none');
        }
    }
}
